import { styled, TextField } from '@mui/material';

import { Density } from '@sbv-clients/util-misc';

import { withTitle } from '../../hoc/with-title';

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'density',
})<{ density?: Density }>(({ density }) => ({
  '& .MuiInputBase-root': {
    height: density === 'comfortable' ? 42 : 32,
    display: 'flex',
    alignItems: 'center',
  },
}));

export const TextFieldWithTitle = withTitle(StyledTextField);
